import { IPromoCategoryDetails } from './seoData';

export interface IPage {
  listingType: TListingType;
  pageType: TPageType;
  siteType: ESiteType;
  extra?: IExtra;
}

export type TListingType = 'list';

export type TPageType = 'ListingPromo';

export enum ESiteType {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}

export interface IExtra {
  [key: string]: string | number | boolean;
}

export interface IPageMeta {
  title: string;
  metaDescription: string;
}

export interface IPageSeo {
  h1: string;
  pageDescription: string;
  promoCategoryDetails: IPromoCategoryDetails | null;
}
